import { graphql } from '../generated';

export const GetSlugs = graphql(`
  query GetSlugs {
    kiaPages(first: 100) {
      nodes {
        slug
        uri
      }
    }
  }
`);

export const GetModuleSlugs = graphql(`
  query GetModuleSlugs {
    kiaModules(first: 100) {
      nodes {
        slug
        uri
      }
    }
  }
`);
